module.exports = __webpack_public_path__ + "img/P4-1-1.972f889b.svg";